import { View } from 'react-native';
import Animated, { FadeIn } from 'react-native-reanimated';
import { WH, WW } from '_utils';
import { screenMargin, smallestMargin } from '_utils/sizes';
import SkeletonLoader from 'Components/SkeletonLoader';

const BookingSharingSkeletonLoader = ({ type }: { type: 'availabilities' | 'requests' }) => {
    return (
        <Animated.View entering={FadeIn.duration(250)} style={{ height: '100%' }}>
            <SkeletonLoader variant="provider" style={{ flex: 1 }}>
                <SkeletonLoader variant="foreground" style={styles.countBar} />
                <SkeletonShareItem index={0} type={type} />
                <SkeletonShareItem index={1} type={type} />
                <SkeletonShareItem index={2} type={type} />
                <SkeletonShareItem index={3} type={type} />
            </SkeletonLoader>
        </Animated.View>
    );
};

const SkeletonShareItem = ({ index, type }: { index: number; type: 'availabilities' | 'requests' }) => {
    return (
        <SkeletonLoader
            variant="background"
            index={index}
            style={[styles.skeletonItem, index > 0 && styles.skeletonItemMarginTop]}
        >
            {/* User avatar */}
            <SkeletonLoader variant="foreground" style={styles.skeletonAvatar} />

            {/* Content area */}
            <View style={styles.skeletonContent}>
                {/* User name */}
                <SkeletonLoader variant="foreground" style={styles.skeletonUserName} />

                {/* Time description */}
                <SkeletonLoader variant="foreground" style={styles.skeletonTimeDescription} />
            </View>

            {/* Action button */}
            <SkeletonLoader
                variant="foreground"
                style={[
                    styles.skeletonButton,
                    type === 'requests' ? styles.skeletonPrimaryButton : styles.skeletonSecondaryButton,
                ]}
            />
        </SkeletonLoader>
    );
};

const styles = {
    countBar: {
        height: WH * 0.025,
        width: '60%' as const,
        borderRadius: 4,
        margin: screenMargin,
        marginBottom: smallestMargin,
    },
    skeletonItem: {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
        paddingHorizontal: screenMargin,
        paddingVertical: smallestMargin,
    },
    skeletonItemMarginTop: {
        marginTop: 0,
    },
    skeletonAvatar: {
        width: WW * 0.18,
        height: WW * 0.18,
        borderRadius: WW * 0.09,
        marginRight: screenMargin,
    },
    skeletonContent: {
        flex: 1,
        gap: WH * 0.01,
    },
    skeletonUserName: {
        height: WH * 0.02,
        width: '70%' as const,
        borderRadius: 4,
    },
    skeletonTimeDescription: {
        height: WH * 0.015,
        width: '50%' as const,
        borderRadius: 4,
    },
    skeletonButton: {
        borderRadius: 20,
        marginLeft: screenMargin,
    },
    skeletonPrimaryButton: {
        width: WW * 0.25,
        height: WH * 0.04,
    },
    skeletonSecondaryButton: {
        width: WW * 0.2,
        height: WH * 0.035,
    },
};

export default BookingSharingSkeletonLoader;
